import React from 'react';
import type { FaqSource } from '../../data/types';
import { FaqSourceType } from '../../data/types';

interface SourceLinkProps {
  source: FaqSource;
}

const getSourceTypeIcon = (type: FaqSourceType) => {
  switch (type) {
    case FaqSourceType.PEER_REVIEWED:
    case FaqSourceType.ACADEMIC:
    case FaqSourceType.ACADEMIC_PREPRINT:
      return (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"></path>
        </svg>
      );
    case FaqSourceType.PRESCRIBING_LABEL:
    case FaqSourceType.MEDICAL_ASSOCIATION:
    case FaqSourceType.MEDICAL_INSTITUTION:
    case FaqSourceType.PHYSICIAN_CLINIC:
    case FaqSourceType.PHYSICIAN_INSTITUTE:
    case FaqSourceType.NONPROFIT_MEDICAL:
      return (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
        </svg>
      );
    case FaqSourceType.REGULATORY:
    case FaqSourceType.GOVERNMENT_HEALTH:
      return (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
        </svg>
      );
    default:
      return (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
        </svg>
      );
  }
};

const formatTypeLabel = (type: FaqSourceType) => {
  return type.replace(/_/g, ' ').toUpperCase();
};

export const SourceLink: React.FC<SourceLinkProps> = ({ source }) => {
  return (
    <a 
      href={source.url} 
      target="_blank" 
      rel="noopener noreferrer"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        padding: '12px',
        background: 'var(--color-bg-tertiary)',
        borderRadius: '8px',
        textDecoration: 'none',
        border: '1px solid var(--color-border)',
      }}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontFamily: 'var(--font-mono)',
        fontSize: '9px',
        color: 'var(--color-text-secondary)',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        fontWeight: 600,
      }}>
        {getSourceTypeIcon(source.type)}
        <span>{formatTypeLabel(source.type)}</span>
      </div>
      <div style={{
        fontFamily: 'var(--font-body)',
        fontSize: '13px',
        color: 'var(--color-text-primary)',
        lineHeight: 1.35,
      }}>
        {source.label}
      </div>
    </a>
  );
};
